<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="71" height="52" fill="white" />
    <path
      opacity="0.8"
      d="M35.459 3.54199C47.9629 3.54199 58.0996 13.6787 58.0996 26.1826C58.0995 38.6864 47.9628 48.8223 35.459 48.8223C22.9552 48.8222 12.8185 38.6864 12.8184 26.1826C12.8184 13.6787 22.9551 3.54203 35.459 3.54199ZM67.6992 18.7559C68.7994 18.7561 69.6914 19.6488 69.6914 20.749C69.6912 21.8491 68.7993 22.741 67.6992 22.7412C66.599 22.7412 65.7062 21.8492 65.7061 20.749C65.7061 19.6487 66.5989 18.7559 67.6992 18.7559ZM13.3623 1.00586C15.4628 1.00596 17.1658 2.70914 17.166 4.80957C17.166 6.91016 15.4629 8.61318 13.3623 8.61328C11.2617 8.61328 9.55859 6.91022 9.55859 4.80957C9.55878 2.70908 11.2618 1.00586 13.3623 1.00586Z"
      fill="url(#paint0_radial_410_32625)"
    />
    <path
      d="M21.7482 21.2523C21.7823 20.5931 22.3267 20.0762 22.9868 20.0762H46.2374C46.9475 20.0762 47.5127 20.6713 47.476 21.3804L46.6741 36.8831C46.64 37.5423 46.0956 38.0592 45.4356 38.0592H22.1849C21.4748 38.0592 20.9097 37.4641 20.9464 36.755L21.7482 21.2523Z"
      fill="url(#paint1_radial_410_32625)"
    />
    <g opacity="0.5" filter="url(#filter0_f_410_32625)">
      <path
        d="M42.8727 36.5072L34.8079 35.6214L38.7688 14.1002L47.6165 15.606C45.6394 20.9627 43.1618 32.6989 42.8727 36.5072Z"
        fill="url(#paint2_radial_410_32625)"
      />
    </g>
    <path
      d="M30.9609 13.156C28.0135 20.072 26.1838 31.3918 25.6374 36.1873L41.894 36.3174C42.9277 25.6186 45.5313 17.7522 46.7039 15.1564L30.9609 13.156Z"
      fill="url(#paint3_radial_410_32625)"
    />
    <g opacity="0.5" filter="url(#filter1_f_410_32625)">
      <path
        d="M39.9589 35.2624L32.1292 35.9367L33.6489 13.928L42.2953 13.7156C40.9662 19.384 39.8328 31.447 39.9589 35.2624Z"
        fill="url(#paint4_radial_410_32625)"
      />
    </g>
    <path
      d="M25.873 14.2502C23.7619 21.6781 23.2028 33.2589 23.1871 38.1208L38.9237 35.1172C38.7794 24.3058 40.4564 16.0015 41.3129 13.2007L25.873 14.2502Z"
      fill="url(#paint5_radial_410_32625)"
    />
    <g opacity="0.5" filter="url(#filter2_f_410_32625)">
      <path
        d="M23.0469 21.7812C23.0469 20.4113 24.1574 19.3008 25.5273 19.3008H29.0986C29.4976 19.3008 29.886 19.4291 30.2066 19.6667L33.0895 21.8042C33.41 22.0419 33.7984 22.1702 34.1975 22.1702L44.3086 22.1702C45.729 22.1702 46.8592 23.3605 46.7857 24.7789L46.2067 35.9528C46.1726 36.6119 45.6282 37.1288 44.9682 37.1288L24.2871 37.1288C23.6021 37.1288 23.0469 36.5736 23.0469 35.8886L23.0469 21.7812Z"
        fill="url(#paint6_radial_410_32625)"
      />
    </g>
    <path
      d="M19.8196 22.7273C19.7207 21.2936 20.857 20.0762 22.2941 20.0762L27.6337 20.0762C28.1675 20.0762 28.6755 20.3054 29.0287 20.7057L30.2432 22.0821C30.5963 22.4824 31.1044 22.7116 31.6381 22.7116H43.083C44.3755 22.7116 45.4513 23.704 45.5554 24.9923L46.503 36.7191C46.5614 37.4411 45.9912 38.0592 45.2668 38.0592H22.0346C21.3827 38.0592 20.8421 37.5546 20.7973 36.9043L19.8196 22.7273Z"
      fill="url(#paint7_radial_410_32625)"
    />
    <rect
      x="31.8164"
      y="33.7129"
      width="9.11598"
      height="1.45856"
      rx="0.620105"
      transform="rotate(180 31.8164 33.7129)"
      fill="url(#paint8_linear_410_32625)"
    />
    <rect
      x="31.8164"
      y="33.7129"
      width="9.11598"
      height="1.45856"
      rx="0.620105"
      transform="rotate(180 31.8164 33.7129)"
      fill="url(#paint9_radial_410_32625)"
    />
    <rect
      x="28.8984"
      y="35.9004"
      width="6.19887"
      height="1.45856"
      rx="0.620105"
      transform="rotate(180 28.8984 35.9004)"
      fill="url(#paint10_linear_410_32625)"
    />
    <rect
      x="28.8984"
      y="35.9004"
      width="6.19887"
      height="1.45856"
      rx="0.620105"
      transform="rotate(180 28.8984 35.9004)"
      fill="url(#paint11_radial_410_32625)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.046 19.9964C41.7482 20.0612 41.4369 20.2592 41.1912 20.6848L38.2823 25.7231C38.1996 25.8664 38.2038 26.0141 38.2952 26.1827C38.3933 26.3636 38.5864 26.5483 38.8338 26.6868C39.0808 26.8251 39.344 26.8959 39.5558 26.8888C39.7588 26.8821 39.8822 26.8095 39.9527 26.6875L41.7984 23.4906C41.8618 23.3808 41.8578 23.301 41.8401 23.2464C41.8198 23.1836 41.7699 23.1208 41.6956 23.0779C41.6212 23.035 41.5419 23.0232 41.4774 23.037C41.4213 23.049 41.3502 23.0854 41.2868 23.1952L39.8713 25.6469C39.7699 25.8226 39.5453 25.8828 39.3696 25.7813C39.194 25.6799 39.1338 25.4554 39.2352 25.2797L40.6508 22.828C40.8118 22.5491 41.0524 22.3768 41.3237 22.3188C41.5866 22.2625 41.8502 22.3191 42.0628 22.4419C42.2754 22.5646 42.4563 22.7646 42.539 23.0204C42.6243 23.2844 42.5955 23.5789 42.4345 23.8578L40.5887 27.0547C40.3594 27.4519 39.9652 27.61 39.5803 27.6229C39.2042 27.6354 38.8091 27.5147 38.4751 27.3277C38.1415 27.141 37.8307 26.8669 37.6495 26.5327C37.4617 26.1863 37.4114 25.7627 37.6463 25.3559L40.5551 20.3175C40.8936 19.7314 41.3697 19.3918 41.8901 19.2787C42.4026 19.1674 42.9221 19.2835 43.3453 19.5394C44.193 20.0522 44.7207 21.1816 44.0534 22.3373L43.8207 22.7111L43.0456 22.7111L43.4174 21.9701C43.8509 21.2191 43.5317 20.5105 42.9651 20.1678C42.6811 19.996 42.3517 19.93 42.046 19.9964Z"
      fill="url(#paint12_radial_410_32625)"
    />
    <defs>
      <filter
        id="filter0_f_410_32625"
        x="33.5684"
        y="12.8594"
        width="15.289"
        height="24.8886"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.620105"
          result="effect1_foregroundBlur_410_32625"
        />
      </filter>
      <filter
        id="filter1_f_410_32625"
        x="30.8887"
        y="12.4746"
        width="12.6484"
        height="24.7031"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.620105"
          result="effect1_foregroundBlur_410_32625"
        />
      </filter>
      <filter
        id="filter2_f_410_32625"
        x="19.9463"
        y="16.2003"
        width="29.9432"
        height="24.0292"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1.55026"
          result="effect1_foregroundBlur_410_32625"
        />
      </filter>
      <radialGradient
        id="paint0_radial_410_32625"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(59.4559 -11.6071) rotate(118.314) scale(74.6291 80.338)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_410_32625"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(54.0244 42.2966) rotate(-145.917) scale(40.02 41.4369)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_410_32625"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(39.1086 24.5539) rotate(21.6457) scale(25.0681 44.6355)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_410_32625"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(57.6798 12.5317) rotate(149.209) scale(42.5025 43.7884)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_410_32625"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(35.0822 24.1837) rotate(11.2839) scale(23.7893 45.5006)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_410_32625"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(51.6476 8.4822) rotate(139.056) scale(43.669 41.7634)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_410_32625"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(35.1389 25.6429) rotate(88.969) scale(34.4645 45.5086)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_410_32625"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(53.1676 42.2966) rotate(-146.223) scale(40.3398 41.5864)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <linearGradient
        id="paint8_linear_410_32625"
        x1="32.19"
        y1="31.2516"
        x2="33.0966"
        y2="37.0208"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D3DAE9" />
        <stop offset="1" stop-color="#D9D9D9" />
      </linearGradient>
      <radialGradient
        id="paint9_radial_410_32625"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(38.6908 27.4912) rotate(122.518) scale(14.5948 34.6791)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <linearGradient
        id="paint10_linear_410_32625"
        x1="29.1525"
        y1="33.4391"
        x2="30.4493"
        y2="39.0511"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D3DAE9" />
        <stop offset="1" stop-color="#D9D9D9" />
      </linearGradient>
      <radialGradient
        id="paint11_radial_410_32625"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.573 29.6787) rotate(113.437) scale(13.4133 25.659)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_410_32625"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(43.7714 18.5625) rotate(127.574) scale(32.8578 11.779)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
    </defs>
  </svg>
</template>
